module.exports = __webpack_public_path__ + "img/city1.ef96b0f.jpg";